<template>
  <div class="home__interact">
    <div class="_box">
      <div class="_col">
        <div>
          <div class="_title">
            Узнайте о проекте больше
          </div>
          <div class="_text texts">
            Хотите уточнить детали? Оставьте свои контакты, чтобы менеджер ответил на ваши вопросы
            при личном разговоре
          </div>
        </div>
        <form autocomplete="off" @keydown.enter="sendRequestForm">
          <div class="_frm-inputs" v-if="!formSent">
            <div>
              <input
                type="text"
                name="interact_name"
                maxlength="50"
                placeholder="Ваше имя"
                v-model="fields[0].value"
                autocomplete="off"
                :class="{ '--errors': fields[0].wrong }"
                @change="checkForm()"
                @keyup="checkForm()"
              />
            </div>
            <div>
              <input
                type="tel"
                name="interact_phone"
                maxlength="50"
                placeholder="Телефон"
                v-model="fields[1].value"
                autocomplete="off"
                ref="phone"
                :class="{ '--errors': fields[1].wrong }"
                @change="checkForm()"
                @keyup="checkForm()"
              />
            </div>
          </div>

          <div class="_frm-inputs _frm-inputs--result" v-if="formSent">
            Спасибо!
          </div>

          <div class="_frm-info">
            Нажимая на кнопку «Оставить телефон», вы даете<br />
            <a href="https://a-residence.ru/files/terms.pdf"
              >согласие на обработку пользовательских данных</a
            >
          </div>
          <div class="_btn" @click="sendRequestForm" :class="{ disabled: formSent }">
            Оставить телефон
          </div>
        </form>
      </div>
      <div class="_col _col--2">
        <div>
          <div class="_title">
            Подберите апартаменты
          </div>
          <div class="_text texts">
            Хотите подобрать апартаменты самостоятельно? Сделайте это в разделе Апартаменты, указав
            все важные для вас параметры
          </div>
        </div>
        <!-- <router-link to="/aparts" class="_btn blocked">
          Подобрать апартаменты (скоро)
        </router-link> -->
        <span class="_btn" @mouseover="btnHover" @mouseout="btnHover" v-if="!$mobView">
          <span :class="!btnHovered ? 'hidden-for-all' : ''">Скоро</span>
          <span :class="btnHovered ? 'hidden-for-all' : ''">Подобрать апартаменты</span>
        </span>
        <span class="_btn" @mouseover="btnHover" @mouseout="btnHover" v-if="$mobView">
          Подобрать апартаменты (скоро)
        </span>
        <div class="_facade">
          <img :src="require('@/assets/img/facades/new/5.2.svg')" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Inputmask from "inputmask"

export default {
  name: "InteractForm",
  data() {
    return {
      fields: [
        { name: "name", wrong: false, value: "" },
        { name: "phone", wrong: false, value: "" },
      ],
      formName: "",
      formPhone: "",
      frmErrors: false,
      formSent: false,
      btnHovered: false,
    }
  },
  methods: {
    btnHover() {
      this.btnHovered = !this.btnHovered
    },
    checkForm() {
      let frmOk = true
      this.fields.forEach(item => {
        item.wrong = !item.value
        if (item.wrong) frmOk = false
      })
      return frmOk
    },
    async sendRequestForm() {
      const elem = document.getElementById("comagic__btn")
      const comagicName = document.getElementById("comagic__name")
      const comagicPhone = document.getElementById("comagic__phone")
      comagicName.setAttribute("value", this.fields[0].value)
      comagicPhone.setAttribute("value", this.fields[1].value)
      elem.click()

      // let utmParams = {
      //   utm_source: "",
      //   utm_medium: "",
      //   utm_term: "",
      //   utm_content: "",
      //   utm_campaign: "",
      // }

      let qsParams = {}

      let querystring = window.location.toString().split("?")
      if (querystring.length > 1) {
        let pairs = querystring[1].split("&")
        for (let i in pairs) {
          let keyval = pairs[i].split("=")
          qsParams[keyval[0]] = keyval[1]
        }
      }

      if (this.checkForm() && !this.formSent) {
        const rawResponse = await fetch(this.$store.getters.getApiUrl + "new_req", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(
            Object.assign({ name: this.fields[0].value, phone: this.fields[1].value }, qsParams)
          ),
        })
        const content = await rawResponse.json()
        if (content.status == 1) this.formSent = true
      }
    },
  },
  mounted() {
    // ... используем
    if (this.$refs.phone != undefined) {
      var im = new Inputmask("+7 (999) 999-99-99")
      im.mask(this.$refs.phone)
    }
  },
}
</script>
